import React from 'react';
import { Button } from '@mui/material';
import { useHistory } from 'react-router';

export default function NotAuthorized({}) {
  const history = useHistory();
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-2 place-content-center min-h-screen">
      <div />
      <div className="p-6">
        <div className=" text-center">
          ขออภัย คุณไม่มีสิทธิในการเข้าถึงหน้าดังกล่าว
        </div>
        <div className="flex justify-center mt-2 gap-2">
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              history.push('/employee');
            }}
          >
            กลับสู่หน้าหลัก
          </Button>
        </div>
      </div>
      <div />
    </div>
  );
}
